module.exports = __webpack_public_path__ + "img/c26264d.jpg";